import Layout from "../../Components/Layout";
import PageHeader from "../../Components/PageHeader";
import { useFinanzasEmpresaLogic } from "../finanzas-empresa/useFinanzasEmpresaLogic";
import { FinanzasSection } from "../finanzas-empresa/finanzasSection";
import {
  FiltroGlobalFecha,
  useFiltroFechaPersistido,
} from "../finanzas-empresa/filtroGlobalFecha";
import { ahoraChile } from "../../utils/fechaChile";

/**
 * Página dedicada de Sueldos — CRUD canónico de los `expenses` con
 * `categoria = "sueldo"`. Mismo razonamiento que `/flujos`: el panel
 * `/finanzas-empresa` pasa a ser puro reporte y cada tipo de movimiento
 * tiene su módulo dedicado.
 *
 * El backend trata sueldos como un caso especial de `expenses` (mismo
 * endpoint POST/PUT/DELETE, distinto `categoria` y filtros de listado).
 * Reusamos `<FinanzasSection titulo="Sueldos">` que internamente:
 *   • Pre-filtra `categoria=sueldo`.
 *   • Oculta los Form.Item de "Rol AF" y "Pagado por" (hidden con
 *     initialValue "paga" y "administrador"). Invariante: los sueldos
 *     son siempre egreso AF — ver docs/modulo-finanzas-empresa.md §3.3.0.
 *   • Muestra un Alert warning al inicio del modal explicando que el
 *     sueldo es pérdida AF.
 *   • `pagadoA` es flexible (aseador / trabajador / receptor externo /
 *     propietario) según necesidad.
 */
export default function SueldosPage() {
  const {
    sidebarOpen,
    toggleSidebar,
    loading,
    usuarios,
    propiedades,
    sueldos,
    createSueldo,
    updateSueldo,
    deleteSueldo,
  } = useFinanzasEmpresaLogic();

  const [filtroFecha, setFiltroFecha] = useFiltroFechaPersistido(
    "sueldos.periodo",
    { modo: "mes", mes: ahoraChile() },
  );

  return (
    <Layout
      sidebarOpen={sidebarOpen}
      toggleSidebar={toggleSidebar}
      containerClass="home-container"
      contentClass="home-content"
    >
      <div className="finanzas-page">
        <PageHeader
          title="Sueldos"
          helpText="CRUD de sueldos pagados a aseadores, trabajadores y otros destinatarios. Siempre representan egreso de Aloja Fácil (pérdida). Para ver el reporte agregado por período, ir a Finanzas de la empresa → Sueldos."
        />

        <div style={{ marginBottom: 16 }}>
          <FiltroGlobalFecha value={filtroFecha} onChange={setFiltroFecha} />
        </div>

        <FinanzasSection
          titulo="Sueldos"
          clavePersistencia="sueldos.tabla"
          data={sueldos}
          loading={loading}
          onCreate={createSueldo}
          onUpdate={updateSueldo}
          onDelete={deleteSueldo}
          usuarios={usuarios}
          propiedades={propiedades}
          filtroFecha={filtroFecha}
        />
      </div>
    </Layout>
  );
}
